import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { palette } from '../../../../../../../settings/themes/colors';
import { DynamicWidget } from './DynamicWidget';
import { WIDGET_TYPES } from './widgetTypes';

const useStyles = makeStyles({
  blockTitle: {
    color: palette.captudataBlue,
    fontFamily: 'Nunito',
    fontSize: 18,
    fontWeight: 700,
    marginTop: 24
  },
  blockDescription: {
    color: palette.dimGray,
    fontSize: 13,
    marginBottom: 12
  },
  cardsGrid: {
    marginBottom: 12
  },
  chartItem: {
    height: 360
  }
});

export const DynamicBlock = ({ block }) => {
  const classes = useStyles();
  const cards = (block.indicators || []).filter(w => w.type === WIDGET_TYPES.STAT);
  const CHART_TYPES = [WIDGET_TYPES.STACKED_BAR, WIDGET_TYPES.BAR, WIDGET_TYPES.BAR_PERCENTAGE];
  const charts = (block.charts || []).filter(w => CHART_TYPES.includes(w.type));

  return (
    <>
      <Typography className={classes.blockTitle}>{block.title}</Typography>
      {block.description ? <Typography className={classes.blockDescription}>{block.description}</Typography> : null}

      {cards.length > 0 && (
        <Grid container spacing={2} className={classes.cardsGrid}>
          {cards.map(card => (
            <Grid item key={card.key} xs={12} sm={6} md={3}>
              <DynamicWidget widget={card} />
            </Grid>
          ))}
        </Grid>
      )}

      {charts.length > 0 && (
        <Grid container spacing={2}>
          {charts.map(chart => (
            <Grid item key={chart.key} xs={12} md={6} className={classes.chartItem}>
              <DynamicWidget widget={chart} />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

DynamicBlock.propTypes = {
  block: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
    indicators: PropTypes.array,
    charts: PropTypes.array
  }).isRequired
};
